import { memo } from 'react';
import VideoUser from 'presentations/views/components/atoms/VideoUser';
import { LiveUser } from 'presentations/api/schema/user';

interface Props {
  localUser: LiveUser;
  isShowIcon: boolean;
  mouseX: number;
  mouseY: number;
}
const Component = memo((props: Props) => {
  const display = props.isShowIcon === false ? 'none' : props.localUser.display;

  const style = {
    left: props.mouseX + 24,
    top: props.mouseY - 0,
    display,
  };
  return (
    <VideoUser
      key={props.localUser.uid}
      name={props.localUser.name}
      color={props.localUser.color}
      style={style}
      isLocalPerson={true}
    />
  );
});
export default Component;
